var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDatabase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 307,
    height: 128,
    viewBox: "0 0 307 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_87_7770)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "database-1",
    d: "M307 42.4096C307 18.9874 288.013 0 264.59 0C241.168 0 222.181 18.9874 222.181 42.4096V128H307V42.4096Z",
    fill: "#CDD0D6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "database-2",
    x: 279,
    y: 80,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#131516"
  }), /*#__PURE__*/React.createElement("path", {
    id: "database-3",
    d: "M287 96C282.582 96 279 92.4184 279 88C279 83.5816 282.582 80 287 80C291.418 80 295 83.5816 295 88C295 92.4184 291.418 96 287 96ZM285.41 88.0135C285.784 88.5038 286.2 89.0323 286.2 89.649V90.4C286.2 90.8418 286.558 91.2 287 91.2C287.442 91.2 287.8 90.8418 287.8 90.4V89.649C287.8 89.0323 288.216 88.5038 288.59 88.0135C288.661 87.9212 288.723 87.8226 288.777 87.7184C288.988 87.3101 289.052 86.8417 288.958 86.392C288.864 85.9422 288.618 85.5384 288.261 85.2486C287.905 84.9588 287.459 84.8006 287 84.8006C286.541 84.8006 286.095 84.9588 285.739 85.2486C285.382 85.5384 285.136 85.9422 285.042 86.392C284.948 86.8417 285.012 87.3101 285.223 87.7184C285.277 87.8226 285.339 87.9212 285.41 88.0135Z",
    fill: "#CDD0D6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "database-4-wrapper"
  }, /*#__PURE__*/React.createElement("path", {
    id: "database-4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70 34.6822C70 15.5278 54.4722 0 35.3178 0C16.1633 0 0.635544 15.5278 0.635544 34.6822V128H70V34.6822Z",
    fill: "#86898D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "database-5-wrapper"
  }, /*#__PURE__*/React.createElement("path", {
    id: "database-5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54 26.9548C54 12.0681 41.9319 0 27.0452 0C12.1584 0 0.0903625 12.0681 0.0903625 26.9548V128H54V26.9548Z",
    fill: "#6B6D71"
  })), /*#__PURE__*/React.createElement("g", {
    id: "database-6-wrapper"
  }, /*#__PURE__*/React.createElement("path", {
    id: "database-6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39 19.2274C39 8.6084 30.3916 0 19.7726 0C9.15359 0 0.545181 8.6084 0.545181 19.2274V128H39V19.2274Z",
    fill: "#414345"
  })), /*#__PURE__*/React.createElement("g", {
    id: "database-7-wrapper"
  }, /*#__PURE__*/React.createElement("path", {
    id: "database-7",
    d: "M23 11.5C23 5.14873 17.8513 0 11.5 0C5.14873 0 0 5.14873 0 11.5V128H23V11.5Z",
    fill: "#313234"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_87_7770"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 307,
    height: 128,
    fill: "white",
    transform: "matrix(-1 0 0 1 307 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatabase);
export default __webpack_public_path__ + "static/media/database.1e4b1c8b34d53fedc612a0c416446f4b.svg";
export { ForwardRef as ReactComponent };